<template>
  <div class="admin">
    <!-- alerta -->
    <div
      class="alert alert-success text-center alert-top animated bounceInUp"
      v-if="alert"
      role="alert"
    >
      El producto se actualizó correctamente!
    </div>
    <!-- /alerta -->

    <div class="fluid-container">
      <div class="row no-gutters">
        <!-- menu admin -->
        <div class="col-3">
          <menu-admin></menu-admin>
        </div>
        <!-- menu admin -->

        <!-- main -->
        <div class="col-9 main">
          <div class="row">
            <div class="col-12 mb-2">
              <div class="title-admin">
                <h1>{{ nombre }} galería</h1>
                <i class="material-icons close-section-icon" @click="back()"
                  >close</i
                >
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <div class="subtitle-action mb-4">
                <h4>Galería de imagenes del producto</h4>
                <button class="btn btn-primary" @click="toggleShow">
                  Seleccionar imagen
                </button>
              </div>

              <!-- loader -->
              <div v-if="loader" class="text-center loader-wrap">
                <div
                  class="spinner-border text-primary"
                  style="width: 75px; height: 75px"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <!-- /loader -->

              <!-- galeria -->
              <div v-if="!loader" class="galeria-admin">
                <!-- existen imagenes -->
                <div v-if="imagenes != ''">
                  <ul>
                    <li v-for="(item, index) in imagenes" :key="item.id">
                      <img :src="item.url" alt />
                      <span
                        v-on:click="removeElement(key, item.id)"
                        class="btn btn-block btn-danger"
                        style="border-radius: 0"
                        >Eliminar imagen</span
                      >
                    </li>
                  </ul>
                </div>
                <!-- /existen imagenes -->

                <!-- galeria  no definida -->
                <div v-else class="imagen-no-definida mt-5">
                  <img
                    style="width: 250px; margin-top: 150px"
                    src="https://image.flaticon.com/icons/svg/137/137665.svg"
                    alt
                  />
                  <span>No se han agregado imágenes a la galería</span>
                </div>
                <!-- /galeria  no definida -->
              </div>
            </div>
          </div>
        </div>
        <!-- /main -->
      </div>

      <div class="row">
        <div class="col-12">
          <my-upload
            field="imagen"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            :width="900"
            :height="900"
            langType="es-MX"
            url="https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=agregarImagenGaleria"
            :params="params"
            :headers="headers"
            img-format="jpg"
          ></my-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { setTimeout } from "timers";
import myUpload from "vue-image-crop-upload";
const axios = require("axios");
export default {
  data() {
    return {
      alert: false,
      nombre: "",
      imagenes: [],
      loader: true,
      id_producto: this.$route.params.id,

      how: true,
      params: {
        id: this.$route.params.id,
      },
      headers: {
        //smail: '*_~'
      },
      imgDataUrl: "", // the datebase64 url of created image,
      show: "",
    };
  },
  components: {
    "my-upload": myUpload,
  },
  methods: {
    getProductoData() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductoData&id=" +
            this.id_producto
        )
        .then((response) => {
          this.nombre = response.data.nombre;
        })
        .catch((error) => console.log(error));
    },

    back() {
      this.$router.go(-1);
    },
    getProductoGaleria() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductoGaleria&id=" +
            this.id_producto
        )
        .then((response) => {
          console.log(response.data);
          this.loader = false;
          this.imagenes = response.data;
        })
        .catch((error) => console.log(error));
    },

    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      this.loader = true;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);

      this.loader = false;
      this.getProductoGaleria();
      this.alert = true;
      setTimeout(() => (this.alert = false), 3000);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    removeElement(index, id) {
      this.loader = true;

      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=eliminarFotoGaleria&id=" +
            id
        )
        .then((response) => {
          this.imagenes.splice(index, 1);
          this.loader = false;
          this.alert = true;
          setTimeout(() => (this.alert = false), 3000);
        })
        .catch((error) => console.log(error));
    },
  },
  computed: {},
  mounted() {
    this.getProductoData();
    this.getProductoGaleria();
  },
};
</script>
